<template>
  <div v-if="title" class="text-lg lg:text-xl" :class="paragraphClassList">
    <div
      :class="{
        'col-span-4 sm:col-span-6 md:col-span-6 md:col-start-2 lg:col-span-8 lg:col-start-3':
          !parentType,
      }"
    >
      <h3
        v-if="parentType == 'accordeon'"
        :id="id"
        v-blokkli-editable:field_title
        class="text-2xl md:text-3xl font-book"
      >
        {{ title }}
      </h3>
      <h2
        v-else
        :id="id"
        v-blokkli-editable:field_title
        :class="{
          'text-center pb-12': parentType == 'link_list',
          'text-2xl md:text-3xl font-book': parentType,
          'text-2xl md:text-3xl lg:text-4xl xl:text-5xl hyphens-auto':
            !parentType,
        }"
      >
        {{ title }}
      </h2>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { slugify } from '#vuepal/helpers/url'

const props = defineProps<{
  title: string
}>()

const { options, parentType } = defineBlokkli({
  bundle: 'title',
  editor: {
    addBehaviour: 'no-form',
    editTitle: (el) => el.textContent,
    getDraggableElement: (el) => el.querySelector('.ck-content'),
    determineVisibleOptions: (ctx) => {
      const options = []
      if (!ctx.parentType) {
        options.push('spacing')
      }
      if (ctx.parentType !== 'accordeon') {
        options.push('showInToc')
      }
      return options
    },
  },
  globalOptions: ['spacing', 'showInToc'],
})

const id = computed(() => slugify(props.title || ''))

const paragraphClassList = computed(() => {
  if (parentType.value === 'teaser_list') {
    return ['mb-5 mt-5 !p-0']
  }

  if (parentType.value === 'accordeon') {
    return ['mb-5']
  }

  const classList = []

  if (options.value.spacing === 'small' && !parentType.value) {
    classList.push('pt-6', 'lg:pt-10')
  } else if (options.value.spacing === 'large' && !parentType.value) {
    classList.push('pt-12', 'lg:pt-20')
  }

  if (!parentType.value) {
    classList.push('grid-container')
  }

  return classList
})
</script>
